import { useMemo } from 'react';

import { useTranslation } from '../../hooks/useTranslation';
import { ClientDataType } from '../../types';
import { EXCLUDED_WHATSAPP_EVENTS } from '../constants';
import { DATA_TYPE_TO_ICON } from '../../constants';
import { doesEventMatchSearch } from '../doesEventMatchSearch';
import { useFilterNonFeatureFlaggedEvents } from './useFilterNonFeatureFlaggedEvents';

type UseEventOptionsProps = {
  search: string;
};

export const useEventOptions = ({ search }: UseEventOptionsProps) => {
  const { t } = useTranslation();
  const filterNonFeatureFlaggedEvents = useFilterNonFeatureFlaggedEvents();

  const options = useMemo(
    () =>
      Object.values(ClientDataType)
        .filter(
          (event) => event !== ClientDataType.User && !EXCLUDED_WHATSAPP_EVENTS.includes(event),
        )
        .filter(filterNonFeatureFlaggedEvents)
        .map((event) => ({
          title: t(`v2.requirementBuilder.eventName.${event}`),
          value: event,
          icon: DATA_TYPE_TO_ICON[event],
        }))
        .filter(({ title }) => doesEventMatchSearch(title, search))
        .sort(({ title: a }, { title: b }) => a.localeCompare(b)),
    [t, search],
  );

  return { options };
};
